import { ModalForm } from "components/ModalForm/ModalForm";

import { MessageType, warehouseIOType } from "types/enum";

import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Toast } from "components/ToastShow/ToastAlert";
import { useEffect, useRef, useState } from "react";
import { convertToISO, trans } from "utils/helpers";
import {
  constraintWarehouseIo,
  getDataForPrint,
  getWarehouseIOByReferenceId,
  getWarehouseIoId,
  getWarehouseIOOrGenerate,
  postWarehouseIO,
  postWarehouseIOWorkFlow,
  putWarehouseIO,
  putWarehouseIOworkflow,
} from "./api";
import WarehouseIOTypeForm from "./components/WarehouseIOTypeForm";
import { Message } from "components/Message/Message";

interface Props {
  mode: string;
  showForm: boolean;
  selectedObj: any;
  processId?: any;
  onHide: () => void;
  reload: () => void;
  type?: any;
  setForceUpdate?: any;
  referenceId?: any;
  taskId?: any;
  jobId?: any;
  JobNo?: any;
  setShowWarehouseIoForm?: any;
  forceUpdate;
  sourceDataParam?: any;
  sourceId?: any;
  useGenerate?: any;
  buttonPrintObjCallBack?: any;
  WarehouseIOKind?: any;
}

export const WarehouseIOForm = ({
  mode,
  showForm,
  selectedObj,
  processId,
  referenceId,
  taskId,
  jobId,
  JobNo,
  onHide,
  reload,
  type = "InventoryRemittance",
  setForceUpdate,
  setShowWarehouseIoForm,
  forceUpdate,
  sourceDataParam,
  sourceId,
  useGenerate = true,
  buttonPrintObjCallBack,
  WarehouseIOKind,
}: Props) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<any>(null);
  const [initilalResponseBeforeCalc, setInitilalResponseBeforeCalc] =
    useState<any>(null); //از این استیت استفاده میکنیم برای نگه داشتن ریسپانس اولیه و در ریسپانس ارور محاسبات بک اند این استیت تغییر نمیکند و مقدار اولیه را در خود نگه میدارد. قابل استفاده برای زمانی که قرار است ادرس ای پی آی بر اساس تغییر تعداد یا آیتم عوض شود
  const [allWarehouseIOData, setAllWarehouseIOData] = useState<any>([]);
  const [selectedWarehouseIoResponse, setSelectedWarehouseIoResponse] =
    useState<any>(null);
  const [constraint, setConstraint] = useState<any>({});
  const [childrenButtonPrintObj, setChildrenButtonPrintObj] = useState<any>();
  const displayType = { dataGrid: 1, modalForm: 2, singleForm: 3 };
  const [url, setUrl] = useState<any>([]);
  const [selectedWarehouseIo, setSelectedWarehouseIo] = useState<any>();
  const [responseList, setResponseList] = useState<any>(null);
  const [childResponseList, setChildResponseList] = useState<any>(null);
  const isPostState = useRef<any>(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showWarehouseTypeForm, setShowWarehouseTypeForm] =
    useState<any>(false);

  const selectedObjCallback = (obj, index) => {
    setSelectedWarehouseIo(obj);
    setSelectedIndex(index);
    setSelectedWarehouseIoResponse(obj);
    if (response.find((item) => item.Id == obj.Id).WarehouseIONo != 0) {
      setChildrenButtonPrintObj({
        Id: obj.Id,
        reportDomain: "OfficeAutomation",
        objectTag: type,
           params:{
                  type
                },
        apiFunction: getDataForPrint,
      });
    } else {
      setChildrenButtonPrintObj(null);
    }
    //setShowWarehouseTypeForm(displayType.modalForm);
  };

  async function handleSendDataAsync(data = allWarehouseIOData, urlParams) {
    if (constraint.IsDocClassified) {
      //   درصورتی که تنطیمات طبقه بندی وجود داشته باشد، اگر حواله انباری بدون طبقه بندی باشد اجازه ارسال فرم ندارد
      const findItemWithoutDocsClassification = data.find(
        (item) => !item.DocsClassificationId
      );
      if (findItemWithoutDocsClassification) {
        Toast(trans("Msg_SetWarehouseIOClassification"), MessageType.error);
        return;
      }
    }
    if (type == "InventoryRemittance" || type == "DirectDelivery"|| type == "ReturnRemittance" || type == "TransferRemittance" || type == "TransferRemittance") {
      data = data.map((item) => {
        return {
          ...item,
          [type+"DetailDTOList"]:
            item?.[type+"DetailDTOList"].map((item1) => {
              return {
                ...item1,
                ExpireDate: item1.ExpireDate
                  ? convertToISO(item1.ExpireDate)
                  : null,
              };
            }),
        };
      });
    }

    data = data.map((item) => {
      return { ...item, WarehouseIODate: convertToISO(item.WarehouseIODate) };
    });
    let totalUrl = "" as any;
    if (jobId) {
      totalUrl = !!urlParams?.length
        ? urlParams.includes("FromSourceWithItemEdit")
          ? "workflowFromSourceWithItemEdit"
          : urlParams.includes("FromSourceWithQtyEdit")
          ? "workflowFromSourceWithQtyEdit"
          : "workflowFromSource"
        : data[0]?.SourceId
        ? "workflowFromSource"
        : (null as any);
    } else {
     totalUrl = !!urlParams?.length
        ? urlParams.includes("FromSourceWithItemEdit")
          ? "FromSourceWithItemEdit"
          : urlParams.includes("FromSourceWithQtyEdit")
          ? "FromSourceWithQtyEdit"
          : "FromSource"
        : data[0]?.SourceId
        ? "FromSource"
        : (null as any);
    }
    // اگر در فرایند باشد و سورس نداشته باشد باید  به ادمیدل درخواست بزند
    // اگر در فرایند باشد و سورس داشته باشه باید به فرامسورس و ... درخواست بزند
    //اگر در فرایند نباشد سورس داشته باشد به فرامسورس درخواست بزند
    //اگر در فرایند نباشد و سورس نداشته باشد پست معمولی است
    try {
      if (mode == "create") {
        let res;
        if (jobId) {
          res = await postWarehouseIOWorkFlow(data, processId, type, totalUrl);
        } else {
          res = await postWarehouseIO(data[0], type, totalUrl);
        }
        // onHide && onHide(true);
        reload();
      } else {
        if (jobId) {
          if (
            response[0]?.WarehouseIONo == 0 ||
            selectedWarehouseIoResponse?.WarehouseIONo == 0 ||
            isPostState.current
          ) {
            const res = await postWarehouseIOWorkFlow(
              data,
              referenceId,
              type,
              totalUrl
            );
            getWarehouseIoByIdAsync();
          } else {
            const res = await putWarehouseIOworkflow(data, referenceId, type);
          }
        } else {
          const res = await putWarehouseIO(data[0], type);
        }
        //  await   putWarehouseIODetail(data)
      }
      isPostState.current = false;
      if (!jobId) setForceUpdate(!forceUpdate);
      onHide && onHide();
    } catch (error: any) {
      if (
        error.response &&
        error.response?.data.MessageType == MessageType.confirm
      ) {
        Toast(trans(error.response?.data.Message), MessageType.confirm, () => {
          //اگر در متد پست به ارور محسابات بخوریم، در ریسپانس دریافتی از بک اند  مقدار شماره حواله تنظیم میشود و اگر دوباره فرم را ذخیره کنیم چون استیت ریسپانس با مقدار ریسپانس از بک اند ست شده پس شماره حواله دارد و وارد متد پوت میشه چون شرط متد پست نداشتن شماره حواله است و این فلگ در شرط باعث تشخیص متد پست است
          if (
            response[0]?.WarehouseIONo == 0 ||
            selectedWarehouseIoResponse?.WarehouseIONo == 0
          ) {
            isPostState.current = true;
          }
          if (jobId) {
            let result: any = [];
          
           
           
           
           
           
            
            allWarehouseIOData.map((item1) => {
              let flag = false;
              const detail = [] as any;
              error.response?.data.Data.map((item2) => {
                if (item2.Id === item1.Id) {
                  if (type == "InventoryRemittance") {
                    item1?.InventoryRemittanceDetailDTOList.map((detail1) => {
    
                      let flag1 = false;

                      item2?.InventoryRemittanceDetailDTOList.map((detail2) => {
                        if (detail1.ItemId == detail2.ItemId ) {
                          detail.push({
                            ...detail2,
                            ExpireDate:detail1.ExpireDate? convertToISO(detail1.ExpireDate) :null,
                          });
                          flag1 = true;
                        }
                      });

                      if (!flag1) {
                        detail.push(detail1);
                      };
                    })

                    result.push({
                      ...item2,
                      WarehouseIODate: item1.WarehouseIODate,
                      InventoryRemittanceDetailDTOList: detail,
                    });
                  } else {
                    result.push({
                      ...item2,
                      WarehouseIODate: item1.WarehouseIODate,
                    });
                  }

                  flag = true;
                }
              });
              if (!flag) {
                result.push(item1);
              }
            });

            setResponse(result);
            setAllWarehouseIOData(result);
          } else {
            setResponse([error.response?.data.Data]);
            setAllWarehouseIOData([error.response?.data.Data]);
          }
        });
      } else {
        let obj = {};
        let childObj = {} as any;
        typeof error.response.data.Data != "string" &&
          !!error.response.data.Data?.length &&
          error.response.data.Data.map((item, index) => {
            if (item?.MessageType == MessageType.error) {
              obj[index] = item;

              if (
                item?.Data &&
                typeof item?.Data != "string" &&
                !!item?.Data?.length
              ) {
                childObj[index] = {};
                item?.Data?.map((item1) => {
                  if (item1?.MessageType == MessageType.error) {
                    childObj[index][item1?.Data] = item1;
                  }
                });
              }
            }
          });
        setResponseList(obj);
        setChildResponseList(childObj);
      }
    }
  }

  const getConstaintWarehouseIoAsync = async (
    withLoading = false,
    warhouseIdList: any
  ) => {
    if (withLoading) {
      setResponse({});
      setInitilalResponseBeforeCalc({});
      setLoading(false);
    }

    try {
      let res =null as any
      if(type!='TransferReceipt') res=  await constraintWarehouseIo(
        warehouseIOType[type],
        warhouseIdList,
        type
      );
      setConstraint(res.Data);
      if (withLoading) setLoading(true);
      return res.Data;
    } catch (error) {
      if (withLoading) setLoading(true);
    }
  };

  async function getWarehouseIoByIdAsync() {
    setLoading(false);
    try {
      let totalRes: any; // برای جمع آوری نهایی ریسپانس ها از هر درخواست گت و تبدیل به آرایه زیرا در بعضی از درخواست ها ریسپانس آرایه نیست و باید به آرایه تبدیل شود.
      let warehouseIdList;
      if (jobId) {
        //بررسی صفحه کارتابل
        let res;
        if (useGenerate || (sourceDataParam && mode != "view")) {
          res = await getWarehouseIOOrGenerate(
            sourceDataParam,
            sourceId,
            referenceId,
            jobId,
            type,
            WarehouseIOKind
          );
        } else {
          res = await getWarehouseIOByReferenceId(referenceId, type);
        }

        if (res.Data.length > 1) {
          //اگر تعداد حواله بیشتر از یک باشد باید دیتاگرید نمایش دهیم ک از داخل آن فرم حواله دلخواه باز شود
          setShowWarehouseTypeForm(displayType.dataGrid);
          buttonPrintObjCallBack && buttonPrintObjCallBack(null);
        } else {
          //اگر ریسپانس شامل آارایه با  یک حواله باشد به صورت مستقیم فرم همان حواله انبار باز می شود.
          setShowWarehouseTypeForm(displayType.singleForm);
          if (!!res.Data.length && res.Data[0].WarehouseIONo != 0) {
            buttonPrintObjCallBack &&
              buttonPrintObjCallBack({
                Id: res.Data[0].Id,
                reportDomain: "OfficeAutomation",
                objectTag: type,
                params:{
                  type
                },
                apiFunction: getDataForPrint,
              });
          } else {
            buttonPrintObjCallBack && buttonPrintObjCallBack(null);
          }
        }

        warehouseIdList = res.Data.map((item, index) => {
          return encodeURI(item.WarehouseId);
        }); //تعیین لیست انبار برای درخواست به کانسرینت

        totalRes = res.Data;
      } else {
        let res = await getWarehouseIoId(selectedObj.Id, type);
        //اگر گت توسط آیدی انجام شود، به صورت مستقیم فرم همان حواله انبار باز می شود.
        setShowWarehouseTypeForm(displayType.singleForm);
        if (res.Data.WarehouseIONo != 0) {
          buttonPrintObjCallBack &&
            buttonPrintObjCallBack({
              Id: res.Data.Id,
              reportDomain: "OfficeAutomation",
              objectTag: type,
              params: {
                type,
              },
              apiFunction: getDataForPrint,
            });
        } else {
          buttonPrintObjCallBack && buttonPrintObjCallBack(null);
        }
        warehouseIdList = res.Data.WarehouseId;
        totalRes = [res.Data];
      }

      let constraintResponse 
      if(mode!='view'){

     constraintResponse=   await getConstaintWarehouseIoAsync(
         false,
         warehouseIdList
       );
      }

      if (
        totalRes[0].WarehouseIONo === 0 &&
        !constraintResponse?.IsDocClassified
      ) {
        //اگر شماره حواله های انبار 0 باشد باید از کانسترینت شماره بگیریم
        const responseWithNewWarehouseIONo = totalRes.map((item) => {
          return {
            ...item,
            WarehouseIONo:
              constraintResponse?.DocNoDictionary[
                Object.keys(constraintResponse?.DocNoDictionary).find(
                  (warehouseId) => warehouseId == item.WarehouseId
                ) as any
              ],
          };
        });

        setAllWarehouseIOData(responseWithNewWarehouseIONo); //نیاز به اپدیت استیت داریم زیرا امکان ذخیره بدون باز کردن فرم وجود دارد و باید حتما دیتا با شماره جدید ارسال شود
      } else {
        //اگر حواله انبار شماره دارد و صفر نیست نیاز به تغییر شماره نداریم
        setAllWarehouseIOData(totalRes);
      }

      setResponse(totalRes); //برای تشخیص اینکه در وضعیت پست یا پوت هست بر اساس شماره، در ریسپانس شماره عوض نمیکنیم.و از ریسپانس اصلی استفاده میکنیم
      setInitilalResponseBeforeCalc(totalRes);
    } catch (error) {}
    setLoading(true);
  }

  useEffect(() => {
    if (mode == "create" && !jobId) {
      //برای مود ایجاد خارج از فرایند و در صفحه اصلی فرم انبار
      setShowWarehouseTypeForm(displayType.singleForm);
      getConstaintWarehouseIoAsync(true, [
        JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id,
      ]);
    } else {
      getWarehouseIoByIdAsync();
    }
  }, []);

  return (
    <div className="card">
      {loading ? (
        response || selectedWarehouseIoResponse ? (
          <>
            {showWarehouseTypeForm == 3 ? (
              //فرم حواله بصورت مستقیم باز میشود در زمانی که ریسپانس فقط یک حواله دارد
              <WarehouseIOTypeForm
                type={type} //string => exmaple InventoryRemittance
                selectedObj={selectedObj}
                showWarehouseTypeForm={showWarehouseTypeForm}
                mode={mode}
                processId={processId}
                showForm={showForm}
                referenceId={referenceId}
                taskId={taskId}
                handleSendData={(data, url,sendData=true) => {
                  setAllWarehouseIOData(
                    allWarehouseIOData.map((item) =>
                      item.Id == data.Id ? data : item
                    )
                  );
              if(sendData)  {  handleSendDataAsync([data], url);
                  if (url) setUrl([url]);}
                }}
                jobId={jobId}
                JobNo={JobNo}
                TAS_UID={taskId}
                sourceDataParam={sourceDataParam}
                data={allWarehouseIOData[0]}
                childResponseList={childResponseList?.[selectedIndex]}
                initialResponse={initilalResponseBeforeCalc[0]}
                reload={() => {
                  setForceUpdate(!forceUpdate);
                }}
                constraint={constraint}
                onHide={() => {
                  setShowWarehouseIoForm(false);
                }}
                warehouseIoEnaumType={
                  //enum => exmaple InventoryRemittance is enum 3 so result is 3
                  selectedObj && mode != "create"
                    ? selectedObj?.WarehouseIOType
                    : warehouseIOType[type]
                }
                setShowWarehouseIoForm={setShowWarehouseIoForm}
              />
            ) : (
              //وقتی روی یکی از سطرهای دیتاگرید کلیک میکنیم فرم حواله دلخواه باز میشود برای زمانی که ریسپانس بیش از یک حواله دارد

              <>
                {" "}
                <ModalForm
                  checkClose={false}
                  onHide={() => setShowWarehouseTypeForm(1)}
                  show={showWarehouseTypeForm == 2}
                  title={type}
                  buttonPrintObj={childrenButtonPrintObj}
                >
                  <WarehouseIOTypeForm
                    type={type} //string => exmaple InventoryRemittance
                    selectedObj={selectedObj}
                    mode={mode}
                    processId={processId}
                    showForm={showForm}
                    childResponseList={childResponseList?.[selectedIndex]}
                    initialResponse={initilalResponseBeforeCalc[selectedIndex]}
                    referenceId={referenceId}
                    taskId={taskId}
                    jobId={jobId}
                    JobNo={JobNo}
                    TAS_UID={taskId}
                    constraint={constraint}
                    handleSendData={(e, newUrl) => {
                      setAllWarehouseIOData(
                        allWarehouseIOData.map((item) =>
                          item.Id == e.Id ? e : item
                        )
                      );
                      if (newUrl) setUrl([...url, newUrl]);
                    }}
                    sourceDataParam={sourceDataParam}
                    data={selectedWarehouseIo}
                    reload={() => {
                      setForceUpdate(!forceUpdate);
                    }}
                    onHide={() => {
                      setShowWarehouseTypeForm(1);
                    }}
                    warehouseIoEnaumType={
                      //enum => exmaple InventoryRemittance is enum 3 so result is 3
                      selectedObj && mode != "create"
                        ? selectedObj?.WarehouseIOType
                        : warehouseIOType[type]
                    }
                    setShowWarehouseIoForm={setShowWarehouseIoForm}
                  />
                </ModalForm>
                <DataGrid
                  parentName={"WarehouseIO"}
                  startIndex={25}
                  handleEdit={(e) => {
                    setSelectedWarehouseIo(e);
                    setSelectedWarehouseIoResponse(e);
                    setShowWarehouseTypeForm(displayType.modalForm);
                  }}
                  convertDateColNames={["WarehouseIODate"]}
                  theadData={Object.keys(response?.[0])}
                  tbodyData={allWarehouseIOData}
                  minCellWidth={80}
                  selectedRowObjectCallback={selectedObjCallback}
                  totalRecords={response.TotalRecords}
                  responseList={responseList ?? null}
                  DoubleClick={(e) => {
                    setSelectedWarehouseIo(e);
                    setSelectedWarehouseIoResponse(e);
                    setShowWarehouseTypeForm(displayType.modalForm);
                  }}
                />
              </>
            )}
          </>
        ) : (
          <Message message={"NoDataForPreview"} type={"info"} />
        )
      ) : (
        <Loading />
      )}

      <div className="my-2">
        {mode != "view" && showWarehouseTypeForm != 3 && (
          <div className="col-lg-12  btns_form mb-3">
            <Button
              // disabled={!(salesOrderDetail.length > 0)}
              value="save"
              btnType="submit"
              onClick={(e) => handleSendDataAsync(allWarehouseIOData, url)}
            />

            <Button
              btnType="cancel"
              value="Cancel"
              onClick={() => {
                setShowWarehouseTypeForm(false);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
